/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_MenuInputs */

const en_nav_app_menu = /** @type {(inputs: Nav_App_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const es_nav_app_menu = /** @type {(inputs: Nav_App_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Nav_App_MenuInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_menu = /** @type {((inputs?: Nav_App_MenuInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_MenuInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_menu(inputs)
	return en_nav_app_menu(inputs)
});